module.exports = __webpack_public_path__ + "fa-regular-400.cd6c777f1945164224de.woff2";


//////////////////
// WEBPACK FOOTER
// E:/SafeCloud-FrontEnd/WebConsorcioPimentel/src/assets/plugins/FontAweson/webfonts/fa-regular-400.woff2
// module id = ../../../../../src/assets/plugins/FontAweson/webfonts/fa-regular-400.woff2
// module chunks = styles